import { SITE, whatsappLink } from "@/config/site";
import { Instagram, Linkedin, MessageCircle } from "lucide-react";

const FOOTER_LINKS = [
  { href: "#sobre", label: "Sobre" },
  { href: "#servicos", label: "Perícia" },
  { href: "#tratamentos", label: "Tratamentos" },
  { href: "#galeria", label: "Galeria" },
  { href: "#faq", label: "FAQ" },
  { href: "#contato", label: "Contato" },
];

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#030303] border-t border-[#D4AF37]/20 pt-20 pb-10"
    >
      <div className="w-full max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-12 border-b border-[#D4AF37]/15">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-4">
              <img
                src={SITE.logoUrl}
                alt={SITE.name}
                className="h-20 w-20 object-contain"
              />
              <div>
                <div className="font-serif-display text-xl text-white">
                  {SITE.shortName}
                </div>
                <div className="text-[11px] tracking-[0.28em] uppercase text-[#D4AF37]/80 mt-1">
                  {SITE.subtitle}
                </div>
              </div>
            </div>
            <p className="mt-6 text-sm text-white/55 leading-relaxed max-w-md">
              Perícias odontológicas técnicas, fundamentadas e imparciais — a
              serviço da justiça e dos profissionais do direito.
            </p>
          </div>

          {/* Nav */}
          <div className="md:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.32em] text-[#D4AF37] mb-5">
              Navegação
            </div>
            <ul className="space-y-3">
              {FOOTER_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.href.replace("#", "")}`}
                    className="text-sm text-white/65 hover:text-[#D4AF37] transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <div className="text-[10px] uppercase tracking-[0.32em] text-[#D4AF37] mb-5">
              Contato
            </div>
            <ul className="space-y-3 text-sm text-white/65">
              <li>
                <a
                  href={`https://wa.me/${SITE.whatsappNumber}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp"
                  className="hover:text-[#D4AF37] transition-colors"
                >
                  WhatsApp: {SITE.whatsappDisplay}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${SITE.email}`}
                  data-testid="footer-email"
                  className="hover:text-[#D4AF37] transition-colors"
                >
                  {SITE.email}
                </a>
              </li>
              <li data-testid="footer-cro">{SITE.cro}</li>
              <li>{SITE.city}</li>
            </ul>

            <div className="mt-6 flex gap-3">
              <a
                href={whatsappLink()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-social-whatsapp"
                aria-label="WhatsApp"
                className="w-10 h-10 border border-[#D4AF37]/30 hover:border-[#D4AF37] hover:bg-[#D4AF37]/10 flex items-center justify-center transition-all"
              >
                <MessageCircle size={16} className="text-[#D4AF37]" />
              </a>
              <a
                href={SITE.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-social-instagram"
                aria-label="Instagram"
                className="w-10 h-10 border border-[#D4AF37]/30 hover:border-[#D4AF37] hover:bg-[#D4AF37]/10 flex items-center justify-center transition-all"
              >
                <Instagram size={16} className="text-[#D4AF37]" />
              </a>
              <a
                href={SITE.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-social-linkedin"
                aria-label="LinkedIn"
                className="w-10 h-10 border border-[#D4AF37]/30 hover:border-[#D4AF37] hover:bg-[#D4AF37]/10 flex items-center justify-center transition-all"
              >
                <Linkedin size={16} className="text-[#D4AF37]" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-white/40 tracking-wide">
            © {new Date().getFullYear()} {SITE.name}. Todos os direitos
            reservados.
          </p>
          <p className="text-[10px] text-white/30 tracking-[0.24em] uppercase">
            Odontologia Legal & Pericial
          </p>
        </div>
      </div>
    </footer>
  );
};
